import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { abstract } from 'ol/util';
import { Subject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { BarrioModel } from 'src/app/core/models/barrio.model';
import { DistintoAmbientalModel } from 'src/app/core/models/distintivo-ambiental.model';
import { SectorModel } from 'src/app/core/models/sector.model';
import { SubBarrioModel } from 'src/app/core/models/sub-barrio.model';
import { TipoAparcamientoModel } from 'src/app/core/models/tipo-aparcamiento.model';
import { TipoCombustibleModel } from 'src/app/core/models/tipo-combustible.model';
import { TipoDocumentoModel } from 'src/app/core/models/tipo-documento.model';
import { TipoPlazaModel } from 'src/app/core/models/tipo-plaza.model';
import { TipoVehiculoModel } from 'src/app/core/models/tipo-vehiculo.model';
import { UsoVehiculoModel } from 'src/app/core/models/uso-vehiculo.model';
import { BarrioService } from 'src/app/core/services/maestras/barrio.service';
import { DistintivoAmbientalService } from 'src/app/core/services/maestras/distintivo-ambiental.service';
import { SectorService } from 'src/app/core/services/maestras/sector.service';
import { SubBarriosService } from 'src/app/core/services/maestras/sub-barrios.service';
import { TipoAparcamientoService } from 'src/app/core/services/maestras/tipo-aparcamiento.service';
import { TipoCombustibleService } from 'src/app/core/services/maestras/tipo-combustible.service';
import { TipoDocumentoService } from 'src/app/core/services/maestras/tipo-documento.service';
import { TipoPlazaService } from 'src/app/core/services/maestras/tipo-plaza.service';
import { TipoVehiculoService } from 'src/app/core/services/maestras/tipo-vehiculo.service';
import { UsoVehiculoService } from 'src/app/core/services/maestras/uso-vehiculo.service';
import { ToastComponent } from 'src/app/theme/components/toast/toast.component';

@Component({
  selector: 'dum-base',
  template: ``
})
export abstract class BaseComponent implements OnInit, OnDestroy {

  @ViewChild('dumToast') dumToast: ToastComponent;

  alive: boolean = true;
  tipoUrl: string;
  loading: boolean = false;
  totalRecord: number;
  cols = [];
  sectores: SectorModel[] = [];
  tipoVehiculos: TipoVehiculoModel[] = [];
  tiposCombustible: TipoCombustibleModel[] = [];
  usosVehiculos: UsoVehiculoModel[] = [];
  distintivosAmbientales: DistintoAmbientalModel[] = [];
  tiposDocumentos: TipoDocumentoModel[] = [];
  clasificacionVehiculos: TipoPlazaModel[] = [];
  tiposAparcamiento: TipoAparcamientoModel[] = [];
  barrios: BarrioModel[] = [];
  subBarrios: SubBarrioModel[] = [];
  unSubscribe: Subject<boolean> = new Subject<boolean>();
  constructor(
    protected sectorService?: SectorService,
    protected tipoVehiculoService?: TipoVehiculoService,
    protected tipoCombustibleService?: TipoCombustibleService,
    protected usosVehiculosServices?: UsoVehiculoService,
    protected distintivosAmbientalesServices?: DistintivoAmbientalService,
    protected clasificacionVehiculoService?: TipoPlazaService,
    protected tipoDocumentoService?: TipoDocumentoService,
    protected tipoAparcamientoService?: TipoAparcamientoService,
    protected barrioService?: BarrioService,
    protected subBarrioService?: SubBarriosService) {}
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.alive = false;
    this.unSubscribe.next(true);
    this.unSubscribe.unsubscribe();
  }

  getSectores() {
    this.sectorService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((sectores) => this.sectores = sectores.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getTipoVehiculo() {
    this.tipoVehiculoService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((tipos) => this.tipoVehiculos = tipos.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getTipoCombustible() {
    this.tipoCombustibleService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((tiposCombustibles) => this.tiposCombustible = tiposCombustibles.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getUsosVehiculos() {
    this.usosVehiculosServices.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((usosVehiculos) => this.usosVehiculos = usosVehiculos.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getDistintivosAmbientales() {
    this.distintivosAmbientalesServices.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((distintivosAmbientales) => this.distintivosAmbientales = distintivosAmbientales.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getClasificacionVehiculos() {
    this.clasificacionVehiculoService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((clasificacionVehiculos) => this.clasificacionVehiculos = clasificacionVehiculos.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getTiposDocumentos() {
    this.tipoDocumentoService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((tiposDocumentos) => {
      this.tiposDocumentos = tiposDocumentos.sort((a, b) => a.nombre.localeCompare(b.nombre));
    });
  }

  getTiposAparcamiento() {
    this.tipoAparcamientoService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((tiposAparcamiento) => this.tiposAparcamiento = tiposAparcamiento.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getBarrios() {
    this.barrioService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((barrios) => this.barrios = barrios.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }

  getSubBarrios() {
    this.subBarrioService.getAll()
    .pipe(takeWhile(() => this.alive))
    .subscribe((subBarrios) => this.subBarrios = subBarrios.sort((a, b) => a.nombre.localeCompare(b.nombre)));
  }
}
